module.exports = __webpack_public_path__ + "static/media/icon-help.cd775853.svg";